export default "https://assets-v2.scaler.com/packs/files/exit-intent-placement.e31652.webp";